import React, { useRef } from 'react';
import ComponentHeader from '../ComponentHeader';

import { getElementIcon } from '../../../FormBuilder/utils';
import { stringToHTML } from '../../../FormBuilder/utils';
import { Tooltip, TextField, FormHelperText } from '@mui/material';

const TextInput = (props) => {
	const inputField = useRef(null);

	const { data, mutable, defaultValue, read_only, disabled, style, ...rest } = props;

	const inputProps = {
		type: 'text',
		className: 'form-control',
		name: data.field_name
	};
	if (mutable) {
		inputProps.defaultValue = defaultValue;
		inputProps.ref = inputField;
	}
	if (read_only) {
		inputProps.disabled = true;
	}

	let baseClasses = 'SortableItem rfb-item';
	if (data.pageBreakBefore) {
		baseClasses += ' alwaysbreak';
	}

	const label = data?.label && data?.label !== ' ' ? data?.label : data?.text;
	const parsedHelperText = stringToHTML(data?.help_message);
	const isFormBuilder = true;

	return (
		<div style={{ ...style }} className={baseClasses}>
			<ComponentHeader {...props} />
			<div className={`form-group${props.isChanged ? ' isChanged' : ''}`}>
				{data.key === 'MUI_LinkInput' ? (
					<div style={{ display: 'flex', gap: '10px' }}>
						{!data?.custom_options?.includes('editOnlyLink') && (
							<TextField
								required={data?.required}
								id="outlined-error-helper-text"
								style={{ width: '100%' }}
								disabled={disabled}
								label={
									<>
										{isFormBuilder && getElementIcon(data?.key)}
										<Tooltip
											title={`${data?.label}${
												isFormBuilder
													? data?.unique_identifier
														? `(ff-${data?.unique_identifier})`
														: `(temp-${data?.temp_order})`
													: ''
											}`}
											placement="top"
										>
											<span>
												<p>
													{`${data?.label}${
														isFormBuilder
															? data?.unique_identifier
																? `(ff-${data?.unique_identifier})`
																: `(temp-${data?.temp_order})`
															: ''
													}`}
												</p>
											</span>
										</Tooltip>
									</>
								}
								multiline
								InputLabelProps={{ shrink: isFormBuilder || undefined }}
							/>
						)}

						<TextField
							required={data?.required}
							id="outlined-error-helper-text"
							style={{ width: '100%' }}
							disabled={disabled}
							label={
								<>
									{isFormBuilder && getElementIcon(data?.key)}
									<Tooltip
										title={`${data?.second_label}${
											isFormBuilder
												? data?.unique_identifier
													? ` (ff-${data?.unique_identifier})`
													: `(temp-${data?.temp_order})`
												: ''
										}`}
										placement="top"
									>
										<p>
											{`${data?.second_label}${
												isFormBuilder
													? data?.unique_identifier
														? ` (ff-${data?.unique_identifier})`
														: `(temp-${data?.temp_order})`
													: ''
											}`}
										</p>
									</Tooltip>
								</>
							}
							multiline
							InputLabelProps={{ shrink: isFormBuilder || undefined }}
						/>
					</div>
				) : (
					<>
						<TextField
							required={data?.required}
							style={{ width: '100%' }}
							disabled={disabled}
							label={
								<>
									{isFormBuilder && getElementIcon(data?.key)}
									<Tooltip
										title={`${label}${
											isFormBuilder
												? data?.unique_identifier
													? ` (ff-${data?.unique_identifier})`
													: `(temp-${data?.temp_order})`
												: ''
										}`}
										placement="top"
									>
										<p>
											{`${label}${
												isFormBuilder
													? data?.unique_identifier
														? ` (ff-${data?.unique_identifier})`
														: `(temp-${data?.temp_order})`
													: ''
											}`}
										</p>
									</Tooltip>
								</>
							}
							multiline
							InputLabelProps={{ shrink: isFormBuilder || undefined }}
						/>
						<FormHelperText error={data?.error}>
							{parsedHelperText?.[0] ? parsedHelperText : data?.help_message}
						</FormHelperText>
					</>
				)}
			</div>
		</div>
	);
};

export default TextInput;
